import { gql } from '@apollo/client';

export default gql`
  mutation UploadOvertimeImage($file: Upload!) {
    uploadImage(file: $file) {
      id
      url
    }
  }
`;
